var _path, _rect, _rect2, _path2, _path3, _path4, _g, _rect3, _ellipse, _ellipse2, _rect4, _path5, _g2, _tspan, _rect5, _rect6, _g3, _path6, _rect7, _g4, _path7, _path8, _rect8, _g5, _path9, _rect9, _tspan2, _rect10, _rect11, _g6, _path10, _rect12, _g7, _path11, _path12, _rect13, _g8, _path13, _rect14, _tspan3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScale2Tubes6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 191,
    viewBox: "0 0 171 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2968 100.69C13.4876 98.8643 15.8232 97.7225 18.3671 97.7225H153.633C156.177 97.7225 158.512 98.8643 159.703 100.69L168.529 114.222C170.044 116.544 167.971 119.341 164.735 119.341H7.26463C4.02878 119.341 1.95595 116.544 3.47064 114.222L12.2968 100.69Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152.3,
    y: 186.273,
    width: 17.5879,
    height: 4.12931,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.96533,
    y: 185.641,
    width: 17.5879,
    height: 4.12931,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96533 146.319C2.96533 130.334 15.9238 117.376 31.9089 117.376H141.074C157.059 117.376 170.017 130.334 170.017 146.319V187.145H2.96533V146.319Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 121.128C1 115.799 5.3195 111.48 10.6479 111.48H161.352C166.68 111.48 171 115.799 171 121.128V185.179H1V121.128Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.364 168.409C150.364 173.738 146.045 178.057 140.716 178.057L30.3012 178.057C24.9728 178.057 20.6533 173.737 20.6533 168.409L20.6533 119.277L150.364 119.278L150.364 168.409Z",
    fill: "#CCD8E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9177_16864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.416 122.289H23.6011V153.891H147.416V122.289Z",
    fill: "#173E50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M94.7556 122.289L35.1785 153.891H73.6147L133.587 122.289H94.7556Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.078 122.289L76.9858 153.891H81.1775L140.662 122.289H136.078Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.783 122.289H24.8875C24.177 122.289 23.6011 122.865 23.6011 123.575V154.246C23.6011 154.957 24.177 155.533 24.8875 155.533H148.783C149.493 155.533 150.069 154.957 150.069 154.246V123.575C150.069 122.865 149.493 122.289 148.783 122.289Z",
    stroke: "#031D29",
    strokeWidth: 2.57277,
    strokeMiterlimit: 10
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.1409,
    y: 102.212,
    width: 34.8025,
    height: 6.32038,
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.2258,
    cy: 95.8921,
    rx: 62.6445,
    ry: 11.3767,
    fill: "#838383"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.5422,
    cy: 93.9958,
    rx: 63.5937,
    ry: 12.0087,
    fill: "#5C5C5C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4987,
    y: 157.211,
    width: 39.8439,
    height: 17.6747,
    rx: 2.25117,
    fill: "#A41034",
    stroke: "#C87085",
    strokeWidth: 1.28638
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9177_16864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 156,
    width: 43,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.02 156.568V161.07V183.582H70.3578V175.863H65.8555L70.3578 171.361V161.07H102.517L107.02 156.568Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9177_16864)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.4987,
    y: 157.211,
    width: 39.8439,
    height: 17.6747,
    rx: 2.25117,
    stroke: "#830D2A",
    strokeWidth: 1.28638
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Bio Sans",
    fontSize: 9.00468,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 77.152,
    y: 169.24
  }, "Zero"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 95,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 76 95)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9177_16864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 79,
    width: 38,
    height: 14
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 93,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 78 93)",
    fill: "#99DFF9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9177_16864)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 93,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 78 93)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8846 91.2788C81.0823 91.2788 78 88.1965 78 84.3943C78 80.592 81.0823 77.5097 84.8846 77.5097L116.974 77.5097L116.974 87.2788C116.974 89.488 115.183 91.2788 112.974 91.2788L84.8846 91.2788Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 81L76 78L117 78L117 81L76 81Z",
    fill: "#F2F7FC"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1072 90.0282C69.45 90.5368 68.4951 90.0684 68.4951 89.2374L68.4951 83.2082C68.4951 82.4106 69.3832 81.934 70.0479 82.3749L74.109 85.069L74.109 86.931L70.1072 90.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9177_16864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 83,
    width: 3,
    height: 6
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 76.604,
    y: 83.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 76.604 83.8276)",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9177_16864)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.604,
    y: 83.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 76.604 83.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.81 83.2069C75.1313 83.2069 75.41 83.4255 75.4661 83.7419C75.556 84.2482 75.6685 85.0682 75.6685 86C75.6685 86.9318 75.556 87.7517 75.4661 88.2581C75.41 88.5745 75.1313 88.7931 74.81 88.7931C74.4229 88.7931 74.1091 88.4793 74.1091 88.0922L74.1091 83.9078C74.1091 83.5207 74.4229 83.2069 74.81 83.2069Z",
    fill: "#EEEEEE"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3574 89.5149C66.7027 89.7655 66 89.2821 66 88.581L66 83.9382C66 83.266 66.65 82.7852 67.2928 82.982L74.1089 85.0689L74.1089 86.931L67.3574 89.5149Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.893 90.0282C125.55 90.5368 126.505 90.0684 126.505 89.2374L126.505 83.2082C126.505 82.4106 125.617 81.934 124.952 82.3749L120.891 85.069L120.891 86.931L124.893 90.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9177_16864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 83,
    width: 3,
    height: 6
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 118.396 83.8276)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9177_16864)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 118.396 83.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.19 83.2069C119.869 83.2069 119.59 83.4255 119.534 83.7419C119.444 84.2482 119.332 85.0682 119.332 86C119.332 86.9318 119.444 87.7517 119.534 88.2581C119.59 88.5745 119.869 88.7931 120.19 88.7931C120.577 88.7931 120.891 88.4793 120.891 88.0922L120.891 83.9078C120.891 83.5207 120.577 83.2069 120.19 83.2069Z",
    fill: "#EEEEEE"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.643 89.5149C128.297 89.7655 129 89.2821 129 88.581L129 83.9382C129 83.266 128.35 82.7852 127.707 82.982L120.891 85.0689L120.891 86.931L127.643 89.5149Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 77,
    width: 18,
    height: 12,
    transform: "rotate(90 104 77)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(90.5 80.5)",
    fill: "#333333",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Bio Sans",
    fontSize: 12,
    letterSpacing: "0px"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 4.39062,
    y: 9.7
  }, "2"))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 100,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 64 100)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9177_16864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 84,
    width: 38,
    height: 14
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 98,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 66 98)",
    fill: "#99DFF9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9177_16864)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 98,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 66 98)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8846 96.2788C69.0823 96.2788 66 93.1965 66 89.3943C66 85.592 69.0823 82.5097 72.8846 82.5097L104.974 82.5097L104.974 92.2788C104.974 94.488 103.183 96.2788 100.974 96.2788L72.8846 96.2788Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 86L64 83L105 83L105 86L64 86Z",
    fill: "#F2F7FC"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1072 95.0282C57.45 95.5368 56.4951 95.0684 56.4951 94.2374L56.4951 88.2082C56.4951 87.4106 57.3832 86.934 58.0479 87.3749L62.109 90.069L62.109 91.931L58.1072 95.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9177_16864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 88,
    width: 3,
    height: 6
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 64.604,
    y: 88.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 64.604 88.8276)",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9177_16864)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.604,
    y: 88.8276,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 64.604 88.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.81 88.2069C63.1313 88.2069 63.41 88.4255 63.4661 88.7419C63.556 89.2482 63.6685 90.0682 63.6685 91C63.6685 91.9318 63.556 92.7517 63.4661 93.2581C63.41 93.5745 63.1313 93.7931 62.81 93.7931C62.4229 93.7931 62.1091 93.4793 62.1091 93.0922L62.1091 88.9078C62.1091 88.5207 62.4229 88.2069 62.81 88.2069Z",
    fill: "#EEEEEE"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3574 94.5149C54.7027 94.7655 54 94.2821 54 93.581L54 88.9382C54 88.266 54.65 87.7852 55.2928 87.982L62.1089 90.0689L62.1089 91.931L55.3574 94.5149Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.893 95.0282C113.55 95.5368 114.505 95.0684 114.505 94.2374L114.505 88.2082C114.505 87.4106 113.617 86.934 112.952 87.3749L108.891 90.069L108.891 91.931L112.893 95.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9177_16864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 88,
    width: 3,
    height: 6
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 106.396 88.8276)",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9177_16864)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 106.396 88.8276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.19 88.2069C107.869 88.2069 107.59 88.4255 107.534 88.7419C107.444 89.2482 107.332 90.0682 107.332 91C107.332 91.9318 107.444 92.7517 107.534 93.2581C107.59 93.5745 107.869 93.7931 108.19 93.7931C108.577 93.7931 108.891 93.4793 108.891 93.0922L108.891 88.9078C108.891 88.5207 108.577 88.2069 108.19 88.2069Z",
    fill: "#EEEEEE"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.643 94.5149C116.297 94.7655 117 94.2821 117 93.581L117 88.9382C117 88.266 116.35 87.7852 115.707 87.982L108.891 90.0689L108.891 91.931L115.643 94.5149Z",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 82,
    width: 18,
    height: 12,
    transform: "rotate(90 92 82)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(78.5 85.5)",
    fill: "#333333",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Bio Sans",
    fontSize: 12,
    letterSpacing: "0px"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 4.39062,
    y: 9.7
  }, "6"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9177_16864"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6011,
    y: 122.289,
    width: 123.815,
    height: 31.6019,
    rx: 1.28638,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale2Tubes6);
export default __webpack_public_path__ + "static/media/Scale_2Tubes_6.f163bddbcae675e32f109f11d4953e0a.svg";
export { ForwardRef as ReactComponent };